import React, { ComponentProps } from 'react';

import A from '@adsk/alloy-react-a';

const UnstyledAnchor = ({ style, ...props }: ComponentProps<typeof A>) => (
  <A
    target="_blank"
    style={[
      {
        color: 'unset',
        textDecoration: 'none',
        ':hover': {
          color: 'unset',
          textDecoration: 'none',
        },
        ':active': {
          color: 'unset',
          textDecoration: 'none',
        },
      },
      style,
    ]}
    {...props}
  />
);

export default UnstyledAnchor;
